import { useDeepEqualValue } from '@superdispatch/hooks';
import { createContext } from 'react';
import { useNullableContext } from 'shared/hooks/useNullableContext';
import { UpdateParams, useLocationParams } from 'shared/routing/LocationParams';
import {
  VehiclesPageFiltersDTO,
  vehiclesPageFiltersSchema,
} from './VehiclesDTO';

interface VehiclesProviderProps {
  filters: VehiclesPageFiltersDTO;
  updateFilters: UpdateParams<VehiclesPageFiltersDTO>;
}

const context = createContext<null | VehiclesProviderProps>(null);

export function useVehiclesPageFilters(): VehiclesProviderProps {
  return useNullableContext('VehiclesProvider', context);
}

export function VehiclesProvider({ children }: { children: React.ReactNode }) {
  const [filters, updateFilters] = useLocationParams({
    zodSchema: vehiclesPageFiltersSchema,
    persistName: 'vehicles-page-filters',
  });

  const ctx = useDeepEqualValue({ filters, updateFilters });

  return <context.Provider value={ctx}>{children}</context.Provider>;
}
